import { Download } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const MemberImportDownloadButton = () => {
  const { t } = useTranslation(['member']);
  return (
    <Button
      component={Link as any}
      to='/importera_medlem_mall.xlsx'
      variant='outlined'
      disableElevation
      size='large'
      download
      target='_blank'
      fullWidth
    >
      <Download sx={{ mr: 1 }} />
      <span>{t('member:importMember.downloadFile')}</span>
    </Button>
  );
};
